import styled from "styled-components";
import { bodyTextBold, bodyTextRegular, breakpoint } from "./style";

const Table = styled.table`
    ${bodyTextRegular}
    font-size: 16pt;
    line-height: 30pt;

    & th {
        ${bodyTextBold}
        text-align: left;
        padding: 10px 50px 10px 0px;
        width: 60%;
        vertical-align: top;
    }

    & td {
        padding: 10px 0px 10px 0px;
        vertical-align: top;
    }

    & ul {
        text-indent: 0px;
        padding: 0px;
        margin: 0px;
        font-size: inherit;
        line-height: inherit;
    }

    & li {
        list-style-type: none;
        padding-left: 0px;
        text-indent: 0px;
        margin-left: 0px;
    }

    @media ${breakpoint.laptop} {
        & th {
            width: 40%;
        }
    }

    @media ${breakpoint.phone} {

            font-size: 14pt;
            line-height: 22pt;
        
    }

`;


const CreativeTeamTable = () => {

    return <Table>
        <tbody>
            <tr>
                <th span="row">Artistic Director</th>
                <td>Ilya Vidrin</td>
            </tr>
            <tr>
                <th span="row">Design and<br />Data Visualization</th>
                <td>Steven Geofrey</td>
            </tr>
            <tr>
                <th span="row">Technology</th>
                <td>Peter Martel</td>
            </tr>
            <tr>
                <th span="row">Engineering and Fabrication</th>
                <td>Eugene Zeleny</td>
            </tr>
            <tr>
                <th span="row">Wearable Glove Design</th>
                <td>Rosa Weinberg</td>
            </tr>
            <tr>
                <th span="row">Musicians</th>
                <td>
                    <ul>
                        <li>Mel Hsu</li>
                        <li>Eric Seligman</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th span="row">Movement Researchers</th>
                <td>
                    <ul>
                        <li>Margot Aknin</li>
                        <li>Elizabeth Epsen</li>
                        <li>Hannah Franz</li>
                        <li>Leah Misano</li>
                        <li>Melissa Sherman-Bennett</li>
                        <li>Valeria Solomonoff</li>
                        <li>Jessi Stegall</li>
                        <li>Cassie Wang</li>
                    </ul>
                </td>
            </tr>
        </tbody>
    </Table>;
};

export default CreativeTeamTable;